"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    items: [1, 2],
    itemsById: {
      1: {
        id: 1,
        link: '#',
        img: '//placehold.it/385x164',
        alt: '385x164',
        text: '',
        collapsed: false,
        type: 'banner'
      },
      2: {
        id: 2,
        link: '#',
        img: '//placehold.it/385x164',
        alt: '385x164',
        text: '',
        collapsed: true,
        type: 'banner'
      }
    },
    itemNextId: 3
  };
}